import React, { useEffect, useState, memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Button, Modal } from 'antd'
import './index.scss'

import RVideo from '@/components/rc-video'
import { UseIntentOrder } from '../intent-modal/order'

const InspectReport = ({ basic, another }) => {
  const basicInfo = basic.basic_info
  const city = useSelector(store => store.city)
  const { fr, ino } = city
  const { phone } = useSelector(store => store.user)
  const inspectorData = basic?.surveyor?.inspector_data
  // 检测报告数据
  const newTestReport = basic?.surveyor?.report_count || {}
  // 是否为复检数据
  const isReInspection = basic?.surveyor?.isReInspection === 1
  // 车源返回的数据，将子项整合进childs,便于遍历
  const initNewTestReport = () => {
    if (newTestReport['重大事故排查']) {
      newTestReport['重大事故排查'].childs = {
        水泡车排查: newTestReport['重大事故排查']['水泡车排查'],
        火烧车排查: newTestReport['重大事故排查']['火烧车排查'],
        重大撞击排查: newTestReport['重大事故排查']['重大撞击排查']
      }
    }
    if (newTestReport['功能部件检测']) {
      newTestReport['功能部件检测'].childs = {};
      [
        '内部配置',
        '动力、传动系统',
        '安全系统',
        '灯光、空调系统',
        '随车工具',
        '转向系统',
        '悬挂系统'
      ].forEach((item) => {
        if (newTestReport['功能部件检测'][item]) {
          newTestReport['功能部件检测'].childs[item] = newTestReport['功能部件检测'][item]
        }
      })
    }

    if (newTestReport['外观内饰检测']) {
      newTestReport['外观内饰检测'].childs = {
        内饰检测: newTestReport['外观内饰检测']['内饰检测'],
        外观检测: newTestReport['外观内饰检测']['外观检测']
      }
    }
  }
  initNewTestReport()

  const renderReportJsx = part => (
    <div key={part}>
      <p className="title">
        <span className="title">{part}</span>
        {newTestReport[part]
          && (!newTestReport[part].childs
            || Object.keys(newTestReport[part].childs).length < 1) && (
          <>
              <i className="iconfont icon-test_icon" />
              <span className="num">
              {newTestReport[part]?.total_pass_num}项
            </span>
              {newTestReport[part]?.defect_num > 0 && (
                <>
                  <i className="iconfont icon-type-part-type-icon" />
                  <span className="num defect">
                    {newTestReport[part].defect_num}项
                  </span>
                </>
              )}
            </>
        )}
      </p>
      {newTestReport[part]?.childs
        && Object.keys(newTestReport[part]?.childs).length > 0 && (
          <ul className="item" key={part}>
            {Object.keys(newTestReport[part].childs).map(
              item => ((item === '随车工具'
                  && newTestReport[part].childs[item]?.has_tool_num > 0)
                  || (item && item !== '随车工具')) && (
                  <li className="clearfix" key={item}>
                    <span className="title">{item}</span>
                    <i className="iconfont icon-test_icon" />
                    <span className="num">
                      {item === '随车工具'
                        ? `${newTestReport[part].childs[item]?.has_tool_num}件`
                        : `${newTestReport[part].childs[item]?.total_pass_num}项`}
                    </span>
                    {newTestReport[part].childs[item]?.defect_num > 0 && (
                      <>
                        <i className="iconfont icon-type-part-type-icon" />
                        <span className="num defect">
                          {newTestReport[part].childs[item]?.defect_num}项
                        </span>
                      </>
                    )}
                  </li>
              )
            )}
          </ul>
      )}
    </div>
  )

  const levelUrl = basic?.surveyor?.standard_temperature?.levelUrl

  const [visible, setVisible] = useState(false)
  const [videoInitTime, setVideoInitTime] = useState(false)
  useEffect(() => {
    if (levelUrl && basicInfo.sell_on_consignment === 1) {
      global.$rbl.push('car-detail_certification_certificate-class_display')
    }
  }, [])
  // 免费咨询
  const toConsult = () => {
    global.$rbl.push('car-detail_certification_button-vehiclecondition')
    const submitParams = {
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}`,
      sub_product: '咨询',
      submit_sources: '咨询-PC-详情页-5'
    }
    const otherParams = { ino, basicInfo }
    new UseIntentOrder({
      intentType: 'consult',
      submitParams,
      otherParams
    }).open()
  }

  return (
    <>
      <div
        className="r-inspectOuter"
        data-exposure="CarDetailPage_Reports_display"
      >
        <div className="r-inspectOuter__inspect">
          <i className="jiaobiao jiaobiao-0 iconfont icon-jiaobiao" />
          <i className="jiaobiao jiaobiao-1 iconfont icon-jiaobiao" />
          <i className="jiaobiao jiaobiao-2 iconfont icon-jiaobiao" />
          <i className="jiaobiao jiaobiao-3 iconfont icon-jiaobiao" />
          {levelUrl && basicInfo.sell_on_consignment === 1 && (
            <div className="car-level">
              <img src={levelUrl} alt="车况等级" />
            </div>
          )}
          <h1 className="header">
            <div className="header-img" /> 249项标准车辆检测报告
          </h1>
          <div className="content clearfix">
            <div className="chekuang">
              <div className="tester-img" />
              <p className="tester-title">高级机动车检测师</p>
              <p className="tester-name">评估师</p>
              <p
                className={`video ${basicInfo?.sold ? 'sold' : ''}`}
                onClick={() => {
                  setVideoInitTime(new Date().getTime())
                  setVisible(true)
                }}
              >
                <i className="iconfont icon-report-play-icon" />
                车辆检测拒绝重大事故车
              </p>
              {!basicInfo?.sold && (
                <Button className="freeconsult-btn" block onClick={toConsult}>
                  免费咨询车况
                </Button>
              )}
              {another?.certificate?.CADACertification === true && (
                <div className="signature clearfix">
                  <div className="signature-img" />
                  <span className="signature-info">
                    中国汽车流通协会
                    <a href="/sell/xingrenzheng" target="_blank">
                      行认证
                    </a>
                  </span>
                </div>
              )}
              {!isReInspection && (
                <p className="signature-note">
                  *以上为初检车况，过户前会安排
                  <a
                    href="https://www.renrenche.com/p/20/fujianjieshao?launch=app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    深度复检
                  </a>
                  ，车况以复检为准
                </p>
              )}
            </div>
            <div className="result">
              <p>{inspectorData?.sum_up_comments}</p>
              <ul className="danger clearfix">
                <li>
                  <i className="iconfont icon-wushigu" />
                  <span>无重大事故</span>
                </li>
                <li>
                  <i className="iconfont icon-wushuipao" />
                  <span>无泡水事故</span>
                </li>
                <li>
                  <i className="iconfont icon-wuhuoshao" />
                  <span>无火烧事故</span>
                </li>
              </ul>
              <ul className="test clearfix">
                <li>
                  {['重大事故排查', '轻微碰撞排查', '易损易耗部件'].filter(item => newTestReport[item]).map(
                    renderReportJsx
                  )}
                </li>
                <li>{['功能部件检测'].filter(item => newTestReport[item]).map(renderReportJsx)}</li>
                <li>
                  {['外观内饰检测', '启动检测', '新能源专项检测'].filter(item => newTestReport[item]).map(
                    renderReportJsx
                  )}
                </li>
              </ul>
            </div>
          </div>
          <a
            href={`https://www.renrenche.com/buy/detail/${basic.carId}/inspect-report-detail`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Button
              className="show-more"
              data-click="CarDetailPage_Reports_CheckDetail_click"
            >
              查看详细检测报告
            </Button>
          </a>
        </div>
      </div>
      <Modal
        destroyOnClose
        bodyStyle={{ padding: '0px' }}
        visible={visible}
        width={854}
        centered
        footer={null}
        onCancel={() => {
          global.$rbl.push(
            `pc_reportvideo_close_${
              (new Date().getTime() - videoInitTime) / 1000
            }`
          )
          setVisible(false)
        }}
        className="r-detail-video-wraper"
      >
        <RVideo
          autoplay
          config={{
            poster: '//img1.rrcimg.com/dist/pc/images/report-video.png',
            src: '//img1.rrcimg.com/dist/pc/100-moments.mp4',
            width: 854,
            height: 512
          }}
        />
      </Modal>
    </>
  )
}

export default memo(InspectReport)

InspectReport.propTypes = {
  basic: PropTypes.object,
  another: PropTypes.object
}

InspectReport.defaultProps = {
  basic: {},
  another: {}
}
